module.exports = __webpack_public_path__ + "img/tx1.a266a241.png";